import {ComputedRef, InjectionKey} from "vue";

export default interface CoreUiChatHistoryExposeInterface {
    $el?: HTMLElement,
    clearSelectedMessages: () => void,
    onScroll: (value: number) => void,
    showMessageNavigator: (payload: MessageNavigatorPayloadInterface) => void,
    scrollToMessageById: (id: number) => void
}

export const SHOW_MESSAGE_STATUS_INJECTION_KEY = Symbol() as InjectionKey<ComputedRef<boolean>>;

export interface MessageNavigatorPayloadInterface {
    title: string;
    messageIds: number[];
    key: string
}